import { Alert, Menu, message, notification } from 'antd';
import { AnimatePresence, motion } from 'framer-motion';
import React, { PureComponent, ReactNode } from 'react';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router-dom';
import { ThunkDispatch } from 'redux-thunk';
import { BOOKING_SLUG } from '../api/constants';
import { Appointment, Patient as ApptPatient } from '../api/fetchAppointmentsV2';
import LeftBar from '../components/common/NavBar';
import {
    APP_VALID_SECTIONS,
    GO_TO_ALL_PATIENTS,
    GO_TO_APPOINTMENTS,
    GO_TO_HE_ONBOARDING,
    GO_TO_NEW_APPOINTMENT,
    GO_TO_PATIENTS_DETAILS,
} from '../routes/paths';
import {
    MISC_KEYS,
    amIDoctorOnly,
    getDoc,
    getDoctorSelectorList,
    getItemFromMisc,
    getMyClinics,
    getMySingleDoctorId,
    getPatientByLocalId,
    getSelectedClinicId,
    setSelectedClinicId,
} from '../store/idbHandler';
import { GlobalState } from '../store/reducers';
import { getAgeInYears } from '../store/utils';
import { dispatch as ekaEventDispath } from '../bridge/events/dispatch';
import endAppointment from '../api/endAppointment';
import { TagRecord } from '../api/fetchAptConfig';
import fetchPrescriptionById, { Px } from '../api/fetchPrescriptionById';
import getHEOnboardingProfile from '../api/getHEOnboardingProfile';
import { requestMedicalRecords } from '../api/requestMedicalRecords';
import RequestMedicalRecords from './RequestMedicalRecords';
import sendSelfAssessmentLink, { Res } from '../api/sendSelfAssessmentLink';
import setPatientAddress from '../api/setPatientAddress';
import { EKA_EVENT, dispatch } from '../bridge/events/dispatch';
import {
    ADD_NEW_MODAL_CLOSE,
    CREATE_ABHA,
    DESTROY_CONTAINER,
    EXPORT_ALL_PT,
    Events,
    INIT_MEDICAL_CERTIFICATE,
    ON_ADD_ADDRESS,
    ON_ADD_PT,
    ON_APPT_ACTION,
    ON_BOOK_LAB_TEST,
    ON_CREATE_TEMPLATE,
    ON_EDIT_PATIENT,
    ON_ENTER_VITALS,
    ON_MR_UPLOAD,
    ON_OPEN_ADMIT_PATIENT_DRAWER,
    ON_OPEN_TREATMENT_PLAN,
    ON_ORDER_MEDICINE,
    ON_REFER_PATIENT,
    ON_REQUEST_ABHA_CREATION,
    ON_REQUEST_MEDICAL_RECORDS,
    ON_SHOW_SA,
    OPEN_URL_IN_IFRAME_DIALOG,
    REFRESH_APPT,
    SHOW_GOOGLE_REVIEW_KNOW_MORE_DIALOG,
    SHOW_TRIAL_PERSUASION_BANNER,
    UPDATE_PATIENT_PROFILE_AND_RELOAD,
} from '../bridge/events/types';
import { renderAppt } from '../bridge/methods';
import ClinicSelector from '../components/common/ClinicSelector';
import EditPatientDetailsDialog from '../components/common/EditPatientDetailsDialog';
import GoToAddPatientBt from '../components/common/GoToAddPateintBt';
import { HEALTH_WEEK_STRIP, HealthWeekStrip } from '../components/common/HealthWeek';
import { followUpIcon } from '../components/common/Icons';
import MedicalCertificateDialog from '../components/common/MedicalCertificateDialog';
import NewHeaderComponent from '../components/common/NewHeaderComponent';
import { AddPtModal } from '../components/common/newaddpt/NewPatientModal';
import AddAddressModal, {
    Address,
} from '../components/prescriptionPad/rightPanel/finishScreen/AddAddressModal';
import { BookLabTestsDialog } from '../components/prescriptionPad/rightPanel/finishScreen/BookLabTests';
import CreateTemplateComp from '../components/prescriptionPad/rightPanel/finishScreen/CreateTemplateDialog';
import { OrderMedicineDialog } from '../components/prescriptionPad/rightPanel/finishScreen/OrderMedicine';
import { getPincode } from '../components/prescriptionPad/rightPanel/finishScreen/OrderMedicineUtils';
import { Actions } from '../store/actions';
import { fetchActiveOrderUpdates, fetchPtDir } from '../store/actions/app';
import { fetchDoc } from '../store/actions/login';
import {
    createPrescriptionTemplate,
    downloadPtDir,
    showDialog,
} from '../store/actions/prescriptionPad';
import {
    toggleGlobalSearch,
    toggleGoogleReviewDialog,
    toggleIframeActionDialog,
} from '../store/actions/session';
import { getGenieSetting } from '../store/selectors/session';
import { Patient } from '../store/types/patient';
import { track } from '../tracking';
import {
    ABORTED,
    ADD_PATIENT,
    APPOINTMENT_DETAILS,
    A_ACTION_TYPE,
    GENDER_CODE_TO_NAME,
    ONGOING,
    PARKED,
    PARKED_ON_OTHER_DEVICE,
    RE_START,
    START_VISIT,
    getAppointmentAction,
    getAppointmentActionTextForAction,
    getPatientNameText,
    onAppointmentAction,
} from './AppointmentUtils';
import { AssessmentSummaryTab } from './PastVisitsRightPanel';
import ApptVitalsAndLabResultsRightPopUp from './appointment/ApptVitalsAndLabResultsRightPopUp';
import { captureError, captureErrorString } from './captureError';
import { HEOnboardingState } from './heOnboarding/HEOnboarding';
import { his } from './history';
import { isDoctor } from './utils';
import { UploadDialog } from './MedicalRecordsRightPanel';
import MRFileSelector from './MRFileSelector';
import { requestAbhaCreation } from '../api/abha/request-abha';
import DoctorReferralAllPatient from '../components/prescriptionPad/leftPanel/DoctorReferralAllPatient';
import { MilestoneUpdatedAt } from '../constants';
import { fetchMilestones } from '../modules/milestone';
import { milestoneDefaultDataVersion } from '../api/getMilestone';
import { ALL_KINDS } from '../utils/enums';
import { getMyDbId } from '../api/mactiveid';
import { LS_KEY_MINIMIZE_DOC_ASSIST, getMActiveId } from '../store/localstorage';
import ModalDialog from '../components/common/ModalDialog';
import DocAssistComp from '../components/prescriptionPad/rightPanel/workspace/DocAssistComp';
import { DOC_ASSIST_LOGO_VIDEO } from './NewQueue';
import ApptTreatmentPlanRightPopUp from './appointment/ApptTreatmentPlanRightPopUp';
import { getAccessControl, showAccessDeniedError } from '../store/AccessControl';
import AdmitPatientDrawer from '../components/IPD/AdmitPatientDrawer';
import { GenieSettings, SREV2 } from '../api/pushGenie';
import { getAclViewClassName } from '../restrictions/utils';
import { IFrameBareDialog } from '../components/common/IFrameDialog';
import { PurchaseEkaCreditsStrip } from './MyKhata';
import NewSignInStrip from '../components/common/NewSignInStrip';

const IPAD_APP_BANNER = 'ipad-app-banner';
interface Props extends RouteComponentProps<RouterProps> {
    dispatch: ThunkDispatch<GlobalState, null, Actions>;
    isHEDeactivated: boolean;
    isHealthWeekDoctorFlag: boolean;
    refreshAllPatients?: boolean;
    isAbdmEnabled: boolean;
    abhaNewFlow: boolean;
    isMilestonesEnabled: boolean;
}

const todayQueueColumnKeys = 'tdy_queue_cols';
const upcomingQueueColumnKeys = 'upco_queue_cols';
const completedQueueColumnKeys = 'cm_queue_cols';
const othersQueueColumnKeys = 'oth_queue_cols';

export type AP = Appointment & { isLocalPresnt: boolean; localRxId?: string; patient: ApptPatient };

export type APWithOptionalpatient = Appointment & { isLocalPresnt: boolean; localRxId?: string };

export type TagRecordWithCount = TagRecord & { count: number };

export type AppointmentConfigs = {
    tags: TagRecordWithCount[];
    user_preferences: {
        [todayQueueColumnKeys]: QueueColumnOptions[0]['key'][];
        [upcomingQueueColumnKeys]: QueueColumnOptions[0]['key'][];
        [completedQueueColumnKeys]: QueueColumnOptions[0]['key'][];
        [othersQueueColumnKeys]: QueueColumnOptions[0]['key'][];
    };
};

type QueueColumnOptions = {
    priority: number;
    key: string;
    required?: boolean;
    renderer: {
        header: JSX.Element;
        renderCell: (a: AP, index: number) => JSX.Element;
    };
}[];

type State = {
    referAP?: AP;
    saAppointment?: AP;
    createTemplateAppointment?: AP;
    vitalsModalAppointment?: AP;
    treatmentPlanModalAppointment?: AP;
    admitPatientDrawerPatient?: Patient;
    orderMedicineDialogVisible?: AP;
    bookLabTestDialogVisible?: AP;
    certPt?: Patient & AP;
    addAddressAppointment?: AP;
    editPatientDialog?: AP;
    abhaDetails?: AP;
    isPancardDetailsMissing?: boolean;
    abhaPatientDialog?: boolean;
    selectedDocid: string;
    newPatientDialog?: boolean;
    MRUploadDialogVisible: boolean;
    files?: File[];
    uploadMrDialogPtId?: string;
    isMRRequestModalOpen: boolean;
    isDialogOpen: boolean;
    MRRequestPt?: {
        id: string;
        abha?: {
            id?: string;
            records?: number;
        };
    };
    certClinicId?: string;
    isMinimizeDocAssist: string | null;
    meetDocAssistDisabled: boolean;
    showVideo: boolean;
};

const APPT_ID = 'appt_id';
const fileUploadId = 'file-upload-old-appt';

type RouterProps = {
    cId: string;
    section: APP_VALID_SECTIONS;
};

class Appointments extends PureComponent<Props, State> {
    state: State = {
        abhaPatientDialog: false,
        newPatientDialog: false,
        MRUploadDialogVisible: false,
        isMRRequestModalOpen: false,
        isMinimizeDocAssist: localStorage.getItem(LS_KEY_MINIMIZE_DOC_ASSIST),
        isDialogOpen: false,
        selectedDocid: getDoc()?._id || '',
        meetDocAssistDisabled: false,
        showVideo: false,
    };

    inputRef: HTMLInputElement | null = null;

    onCreateTemplate = (a: AP): void => {
        this.setState({
            createTemplateAppointment: a,
        });
    };

    closeCreateTemplateDialog = (): void => {
        this.setState({
            createTemplateAppointment: undefined,
        });
    };

    VALID_SECTIONS: Set<APP_VALID_SECTIONS> = new Set([
        'today-queue',
        'upcoming',
        'completed',
        'others',
        'follow-ups',
    ]);

    checkForValidUrlParams = (): boolean => {
        const clinics = getMyClinics();
        if (
            clinics?.find((c) => c._id === this.props.match.params.cId) &&
            this.VALID_SECTIONS.has(this.props.match.params.section)
        ) {
        } else {
            const cId =
                clinics?.find((c) => c._id === this.props.match.params.cId)?._id ||
                getSelectedClinicId() ||
                '';
            if (!cId) {
                captureError(new Error("Default client not found in user's clinics"));
                return false;
            }
            const section = this.VALID_SECTIONS.has(this.props.match.params.section)
                ? this.props.match.params.section
                : 'today-queue';
            const t = GO_TO_APPOINTMENTS(cId, section);
            this.props.history.replace(t);
        }

        return true;
    };

    renderStuff = (): void => {
        const configs = {
            containerId: APPT_ID,
            routeParams: this.props.match.params,
            queryParams: this.props.location.search,
        };
        window.APPT_CONFIGS = configs;
        try {
            renderAppt(configs);
        } catch (e) {
            console.log(e);
            captureError(e as Error);
        }
    };

    componentDidMount = async (): Promise<void> => {
        if (!this.checkForValidUrlParams()) {
            return;
        }
        this.renderStuff();

        const categories = getDoc()?.profile.professional.category || [];
        const isNosa = categories.includes('NOSA');
        const hasSaas = getDoc()?.profile.professional.saas;

        if (!isNosa && !hasSaas) {
            ekaEventDispath({
                type: SHOW_TRIAL_PERSUASION_BANNER,
            });
        }

        fetchPtDir();
        fetchActiveOrderUpdates();

        const lastUpdated = await getItemFromMisc<MilestoneUpdatedAt>(
            getMyDbId() || '',
            MISC_KEYS.milestonesLastUpdatedAt,
        );

        const { meetDocAssistDisabled } = await getItemFromMisc<GenieSettings>(
            getMActiveId() || '',
            'settings',
        );
        this.setState({ meetDocAssistDisabled: meetDocAssistDisabled });

        if (
            this.props.isMilestonesEnabled &&
            (!lastUpdated.isoString ||
                !lastUpdated.version ||
                lastUpdated.version !== milestoneDefaultDataVersion)
        )
            fetchMilestones();

        this.props.dispatch(fetchDoc(getDoc()?._id || ''));

        window.addEventListener(EKA_EVENT, this.onEkaEvents);
        window.addEventListener('message', this.onABHAEkaEvents);
        this.getHEOnboardingProfile();
    };

    componentDidUpdate(prevProps: Props): void {
        if (
            this.props.match.params.cId !== prevProps.match.params.cId ||
            this.props.match.params.section !== prevProps.match.params.section
        ) {
            if (!this.checkForValidUrlParams()) {
                return;
            }
            this.renderStuff();
        }

        if (this.props.refreshAllPatients !== prevProps.refreshAllPatients) {
            this.hardRefresh();
        }
    }

    componentWillUnmount = (): void => {
        dispatch({ type: DESTROY_CONTAINER, containerId: APPT_ID });
        window.removeEventListener(EKA_EVENT, this.onEkaEvents);
        window.removeEventListener('message', this.onABHAEkaEvents);
        window.APPT_CONFIGS = undefined;
    };

    getHEOnboardingProfile = async (): Promise<void> => {
        const isPancardDetailsSubmitted = localStorage.getItem('isPancardDetailsSubmitted');
        if (isPancardDetailsSubmitted) return;
        try {
            const { success, profile, error = '' } = await getHEOnboardingProfile();
            if (success && profile) {
                const { pancard = '' } = profile;
                const isPancardDetailsMissing = pancard.trim().length !== 10;
                this.setState({ isPancardDetailsMissing });
                if (!isPancardDetailsMissing) {
                    localStorage.setItem('isPancardDetailsSubmitted', 'true');
                }
            } else {
                captureErrorString(error);
                track('ERROR', { on: 'getHEOnboardingProfile', what: error });
            }
        } catch (error) {
            captureError(error as Error);
            track('ERROR', {
                on: 'getHEOnboardingProfile',
                error: (error as Error).message,
            });
        }
    };

    onEkaEvents: EventListener = (e: Event): void => {
        const { detail } = e as CustomEvent<Events>;

        if (!getAccessControl().isAllowed(detail.type)) {
            showAccessDeniedError();
            return;
        }

        switch (detail.type) {
            case SHOW_GOOGLE_REVIEW_KNOW_MORE_DIALOG:
                this.props.dispatch(toggleGoogleReviewDialog(detail.docid));
                break;
            case EXPORT_ALL_PT:
                this.exportAsExcel();
                break;
            case INIT_MEDICAL_CERTIFICATE:
                this.setMedicalCertPt(detail.ap);
                break;
            case OPEN_URL_IN_IFRAME_DIALOG:
                this.props.dispatch(toggleIframeActionDialog(detail.url));
                break;
            case ON_APPT_ACTION:
                onAppointmentAction(
                    this,
                    detail.a,
                    detail.cId,
                    undefined,
                    detail.dontAllowStartVisit,
                    detail.isNotesMode,
                );
                break;
            case ON_REQUEST_MEDICAL_RECORDS:
                this.setMrUploadPt(detail.a);
                break;
            case ON_REQUEST_ABHA_CREATION:
                this.sendCreateABHARequest(detail.a);
                break;
            case ON_ADD_ADDRESS:
                this.setState({ addAddressAppointment: detail.a });
                break;
            case ON_REFER_PATIENT:
                this.setState({
                    referAP: detail.a,
                });
                break;
            case ON_SHOW_SA:
                this.setState({
                    saAppointment: detail.a,
                });
                break;
            case ON_CREATE_TEMPLATE:
                this.onCreateTemplate(detail.a);
                break;
            case ON_ORDER_MEDICINE:
                this.showOrderMedicineDialogVisible(detail.a);
                break;
            case ON_BOOK_LAB_TEST:
                this.showBookLabTestDialogVisible(detail.a);
                break;
            case ON_ENTER_VITALS:
                this.onEnterVitals(detail.a);
                break;
            case ON_OPEN_TREATMENT_PLAN:
                this.onOpenTreatmentPlan(detail.a);
                break;
            case ON_OPEN_ADMIT_PATIENT_DRAWER:
                this.onOpenAdmitPatientDrawer(detail.a);
                break;
            case ON_EDIT_PATIENT:
                this.setState({
                    editPatientDialog: detail.a,
                });
                break;
            case CREATE_ABHA:
                this.setABHAAppointmentDetails(detail.docid, detail.a);
                break;
            case ON_ADD_PT:
                this.toggleNewPtDialog(true, detail.docid);
                break;
            case ON_MR_UPLOAD:
                this.openMRUploadFilePicker(detail.ptOid);
                break;
        }
    };

    onABHAEkaEvents: EventListener = (e: any): void => {
        const type = e?.data?.type;

        switch (type) {
            case UPDATE_PATIENT_PROFILE_AND_RELOAD:
                this.setState({ abhaDetails: undefined, abhaPatientDialog: false });
                break;
        }
    };

    mrUploaddeets = (
        docid: string,
        ptId: string,
        abha?: {
            id?: string | undefined;
            records?: number | undefined;
        },
    ): void => {
        const isAbdm = this.props.isAbdmEnabled;

        track('REQUEST_MEDICAL_RECORDS', {
            isABDM: isAbdm?.toString(),
            abhaId: abha?.id,
            consentRequest: (isAbdm && abha && abha?.id)?.toString(),
            on: 'old-queue',
        });

        if (isAbdm === false) {
            requestMedicalRecords(docid, ptId, () => {
                notification.success({
                    message: `Medical Records Requested ✅`,
                    duration: 5,
                    placement: 'topRight',
                });
            });
            return;
        }

        if (abha?.id) {
            this.setState({
                isMRRequestModalOpen: true,
                MRRequestPt: { id: ptId, abha },
            });
            return;
        }

        requestMedicalRecords(docid, ptId, () => {
            notification.success({
                message: `Medical Records Requested ✅`,
                duration: 5,
                placement: 'topRight',
            });
        });
    };

    setMrUploadPt = async (appPt: AP) => {
        try {
            if (appPt?.patient_oid) {
                this.mrUploaddeets(appPt.doctor_oid, appPt?.patient_oid, appPt.abha);
                return;
            }

            throw new Error('Patient id not found');
        } catch (error) {
            track('ERROR', { on: 'requestMedicalRecords', what: (error as Error)?.message });
            captureError(error as Error);
        }
    };

    sendCreateABHARequest = (a: AP): void => {
        if (a.patient_oid) {
            requestAbhaCreation(
                a.patient_oid,
                () =>
                    notification.success({
                        message: 'ABHA creation request sent successfully!',
                        duration: 5,
                    }),
                () =>
                    notification.error({
                        message: 'Something went wrong!',
                        duration: 5,
                    }),
            );
        }
    };

    openMRUploadFilePicker = (ptOid: string): void => {
        this.setState({ uploadMrDialogPtId: ptOid });
        if (this.inputRef) this.inputRef.click();
    };

    toggleNewPtDialog = (value: boolean, docid?: string): void => {
        this.setState({
            newPatientDialog: value,
            selectedDocid: docid || this.state.selectedDocid,
        });
    };

    onClinicSelect = (selectedClinicId: string): void => {
        this.props.history.replace(
            GO_TO_APPOINTMENTS(selectedClinicId, this.props.match.params.section),
        );
    };

    onEnterVitals = (a: AP): void => {
        if (getAppointmentAction(a) === ADD_PATIENT) {
            notification.error({
                message: 'Add Patient for this appointment first',
                duration: 5,
            });
            return;
        }

        this.setState({
            vitalsModalAppointment: a,
        });
    };

    closeVitalsDialog = (): void => {
        this.setState({
            vitalsModalAppointment: undefined,
        });
    };

    onOpenTreatmentPlan = (a: AP): void => {
        this.setState({
            treatmentPlanModalAppointment: a,
        });
        track('ON_OPEN_TREATMENT_PLAN', { from: 'Old Queue' });
    };

    onCloseTreatmentPlan = (): void => {
        this.setState({
            treatmentPlanModalAppointment: undefined,
        });
        track('ON_CLOSE_TREATMENT_PLAN', { from: 'Old Queue' });
    };

    onOpenAdmitPatientDrawer = async (a: AP): Promise<void> => {
        if (!a.patient_oid) return;
        const pt = await getPatientByLocalId(a.patient_oid);
        this.setState({
            admitPatientDrawerPatient: pt,
        });
        track('ON_OPEN_ADMIT_PATIENT_DRAWER', { from: 'Old Queue' });
    };

    onCloseAdmitPatientDrawer = (): void => {
        this.setState({
            admitPatientDrawerPatient: undefined,
        });
        track('ON_OPEN_ADMIT_PATIENT_DRAWER', { from: 'Old Queue' });
    };

    onAppointmentViewDetials = (aid: string, manage?: boolean): void => {
        this.props.dispatch(
            toggleIframeActionDialog(
                `${BOOKING_SLUG}/appointment/${aid}${manage ? '?manage=true' : ''}`,
            ),
        );
    };

    onSendAssessmentClick = (aid: string, name?: string | null): void => {
        sendSelfAssessmentLink(aid)
            .then((res: Res) => {
                if (res.success) {
                    notification.success({
                        message: `Assessment send to ${name}`,
                        placement: 'bottomRight',
                        duration: 5,
                    });
                } else {
                    notification.error({
                        message: res?.error?.type,
                        placement: 'bottomRight',
                        duration: 5,
                    });
                }
            })
            .catch((e) => {
                message.error('Request failed retry!');
                console.error(e);
            });
    };

    onReferADoc = (a: AP): void => {
        if (!a.patient_oid) {
            alert('Add patient first to refer');
            return;
        }
        this.setState({
            referAP: a,
        });
    };

    onShowSa = (a: AP): void => {
        track('OPEN_SA', {
            channel: 'APPOINTMENTS',
            apptVisitType: a['visit-type'],
            apptChannel: a.channel,
        });
        this.setState({
            saAppointment: a,
        });
    };

    onCloseSa = (): void => {
        this.setState({
            saAppointment: undefined,
        });
    };

    closeReferalDialog = (): void => {
        this.setState({
            referAP: undefined,
        });
    };

    onSaveAsTemplate = async (name: string, id?: string): Promise<void> => {
        const pxId = this.state.createTemplateAppointment?.prescription_id;

        if (!pxId) {
            alert('Something went wrong');
            this.closeCreateTemplateDialog();
            return;
        }

        let px: Px | undefined;

        try {
            px = await fetchPrescriptionById(pxId);
        } catch (e) {
            alert('Unable to fetch prescription');
            this.closeCreateTemplateDialog();
            return;
        }

        const { dispatch } = this.props;
        dispatch(createPrescriptionTemplate('PX', name, id, px?.tool));
        this.closeCreateTemplateDialog();
    };

    exportAsExcel = (): void => {
        this.props.dispatch(downloadPtDir());
    };

    onFocusInput = (): void => {
        const { match, history } = this.props;
        const { cId } = match.params;
        history.replace(GO_TO_ALL_PATIENTS(cId));
    };

    setMedicalCertPt = async (ap?: AP): Promise<void> => {
        if (!ap?.patient_oid) {
            this.setState({
                certPt: undefined,
            });
            return;
        }
        if (ap?.patient_oid) {
            const pt = await getPatientByLocalId(ap.patient_oid);
            this.setState({
                certPt: { ...pt, ...ap },
                certClinicId: ap.clinic_id,
            });
        }
    };

    showOrderMedicineDialogVisible = (appt: AP): void => {
        this.setState({
            orderMedicineDialogVisible: appt,
        });
        track('ORDER_MEDICINE', { pxId: appt.prescription_id || '' });
    };

    hideOrderMedicineDialogVisible = (): void => {
        this.setState({
            orderMedicineDialogVisible: undefined,
        });
    };

    showBookLabTestDialogVisible = (appt: AP): void => {
        this.setState({
            bookLabTestDialogVisible: appt,
        });
        track('BOOK_LAB_TEST', { pxId: appt.prescription_id || '' });
    };

    hideBookLabTestDialogVisible = (): void => {
        this.setState({
            bookLabTestDialogVisible: undefined,
        });
    };

    onEndVisit = (a: Appointment): void => {
        endAppointment({
            status: 'CMNP',
            visitId: a.aid,
            docId: getDoc()?._id || '',
            ptOid: a.patient_oid || '',
            startDateTime: a.start_time,
            endDateTime: new Date().toISOString(),
            clinicId: a.clinic_id,
        })
            .then((res) => {
                if (res.success !== true) {
                    alert('Failed to end visit');
                } else {
                    this.hardRefresh();
                }
            })
            .catch((e) => {
                console.error(e);
                alert('Failed to end visit');
            });
    };

    CLOSE_SA_DIA_CTA = (): JSX.Element => (
        <div className="flex items-center justify-between p-16 border-t border-neutral-7">
            <div></div>
            <div className="space-x-16">
                <button onClick={this.onCloseSa} className="primary-btn  px-12 py-8 btn--small ">
                    <span className="w-full text-center">Close</span>
                </button>
            </div>
        </div>
    );

    UPCOMING_SA_DIA_CTA = (saAppointment: AP): JSX.Element => (
        <div className="flex items-center justify-between p-16 border-t border-neutral-7">
            <div>
                <button onClick={this.onCloseSa} className="neutral-btn  px-12 py-8 btn--small ">
                    <span className="w-full text-center">Cancel</span>
                </button>
            </div>
            <div className="space-x-16">
                <button
                    onClick={() => {
                        this.onEndVisit(saAppointment);
                        this.onCloseSa();
                    }}
                    className="secondary-btn  px-12 py-8 btn--small "
                >
                    <span className="w-full text-center">End Visit</span>
                </button>
                <button
                    onClick={() =>
                        onAppointmentAction(this, saAppointment, this.props.match.params.cId)
                    }
                    className="primary-btn  px-12 py-8 btn--small "
                >
                    <span className="flex w-full text-center">
                        {getAppointmentActionTextForAction(
                            getAppointmentAction(saAppointment),
                            true,
                        )}
                    </span>
                </button>
            </div>
        </div>
    );

    hardRefresh = (): void => {
        dispatch({ type: REFRESH_APPT });
    };

    setAddressHandler = (address: Address): void => {
        const { _id, line, address: add, city, state, placeID, latLng, pincode } = address;
        const docId = getMySingleDoctorId() || '';

        if (!add || !line || !city || !state || !pincode) {
            notification.error({
                message: 'Please fill all fields',
                duration: 5,
                placement: 'topRight',
            });
            return;
        }

        setPatientAddress(docId, {
            _id,
            pid: this.state.addAddressAppointment?.patient_oid || '',
            address: {
                line1: line,
                line2: add,
                city,
                state,
                place_id: placeID,
                coordinates: latLng,
                pincode,
            },
        })
            .then((i) => {
                if (i.success) {
                    notification.success({
                        message: 'Address saved succesfully!',
                        duration: 5,
                        placement: 'topRight',
                    });
                } else {
                    notification.error({
                        message: i.error,
                        duration: 5,
                        placement: 'topRight',
                    });
                }
                this.setState({ addAddressAppointment: undefined });
            })
            .catch((err) => {
                notification.error({
                    message: err.error,
                    duration: 5,
                    placement: 'topRight',
                });
                this.setState({ addAddressAppointment: undefined });
            });
    };

    onClose = (): void => {
        localStorage.setItem(IPAD_APP_BANNER, 'false');
        track('CROSS', {
            element: 'ipad app download banner',
        });
    };

    editPatientComplete = (): void => {
        this.closeEditPatientDialog();
        this.hardRefresh();
    };

    closeEditPatientDialog = (): void => this.setState({ editPatientDialog: undefined });

    setABHAAppointmentDetails = (docid: string, a?: AP): void => {
        this.setState({
            abhaDetails: a,
            abhaPatientDialog: true,
            selectedDocid: a?.doctor_oid || docid,
        });
    };

    goToHEOnboarding = (step: HEOnboardingState): void => {
        const { history } = this.props;
        history.replace(GO_TO_HE_ONBOARDING(step));
        track('GO_TO_HE_ONBOARDING_WARNING_BUTTON', { step });
    };

    showHealthWeek = (): void => {
        const { dispatch } = this.props;
        dispatch(showDialog('health-week'));
    };

    closeAddNewPatientModal = (): void => {
        dispatch({
            type: ADD_NEW_MODAL_CLOSE,
        });
        this.toggleNewPtDialog(false);
    };

    closeMRDialog = (): void => {
        this.setState({ MRUploadDialogVisible: false });
    };

    onFilesSelect = (e: any): void => {
        if (!e.target.files) {
            return;
        }

        this.setState({
            files: Array.from(e.target.files),
            MRUploadDialogVisible: true,
        });
    };

    onRefChange = (ref: HTMLInputElement | null): void => {
        this.inputRef = ref;
    };

    setFiles = (files: File[]): void => {
        this.setState({ files });
    };

    closeRequestMedicalRecords = () =>
        this.setState({ isMRRequestModalOpen: false, MRRequestPt: undefined });

    openDialog = () => {
        this.setState({ isDialogOpen: true });
    };

    closeDialog = () => {
        this.setState({ isDialogOpen: false });
    };

    minimizeDocAssist = () => {
        localStorage.setItem(LS_KEY_MINIMIZE_DOC_ASSIST, 'true');
        this.setState({ isMinimizeDocAssist: 'true' });
    };

    render(): ReactNode {
        const { isHEDeactivated, isHealthWeekDoctorFlag } = this.props;
        const {
            referAP,
            saAppointment,
            createTemplateAppointment,
            certPt,
            vitalsModalAppointment,
            treatmentPlanModalAppointment,
            admitPatientDrawerPatient,
            orderMedicineDialogVisible,
            bookLabTestDialogVisible,
            addAddressAppointment,
            editPatientDialog,
            abhaDetails,
            isPancardDetailsMissing,
            abhaPatientDialog,
            selectedDocid,
            MRUploadDialogVisible,
            files,
            uploadMrDialogPtId,
            newPatientDialog,
            isMRRequestModalOpen,
            MRRequestPt,
            certClinicId,
            isMinimizeDocAssist,
            isDialogOpen,
            meetDocAssistDisabled,
            showVideo,
        } = this.state;
        const isHealthWeekDoctor = isHealthWeekDoctorFlag && isDoctor();

        const { section } = this.props.match.params;

        let gen = orderMedicineDialogVisible?.patient.gen || bookLabTestDialogVisible?.patient.gen;

        if (gen === 'M') gen = 'male';
        else if (gen === 'F') gen = 'female';
        else gen = 'others';

        const newQueueIntro = () => {
            track('playing_new_queue_intro_video');
            this.setState({ showVideo: true });
        };
        const age =
            getAgeInYears({
                dob:
                    orderMedicineDialogVisible?.patient.dob ||
                    bookLabTestDialogVisible?.patient.dob,
            }) || 18;
        const clinics = getDoc()?.profile.professional.clinics || [];
        const currentClinicId =
            orderMedicineDialogVisible?.clinic_id || bookLabTestDialogVisible?.clinic_id;
        const currentClinic = clinics.find((i) => i._id === currentClinicId);
        const pincode = getPincode({
            id: addAddressAppointment?.patient_oid || '',
            formData: addAddressAppointment?.formData || [],
        } as Patient);
        const doc = getDoc();
        const isStaff = doc?.loginmeta?.role === 'STAFF';
        const showHealthWeekStripArrow = localStorage.getItem(HEALTH_WEEK_STRIP) !== 'true';

        const clinicHfr = doc?.profile.professional.clinics?.find(
            (c) => c._id === (this.props.match.params.cId ?? getSelectedClinicId()),
        )?.abdm?.hfr_id;

        const defaultFormState =
            this.props.isAbdmEnabled && !!clinicHfr
                ? this.props.abhaNewFlow
                    ? 'abha'
                    : 'add-pt'
                : 'add-pt';

        const MRRequestPtId = MRRequestPt?.id ?? '';

        return (
            <>
                <div className="flex flex-col w-full h-full bg-white font-lato">
                    <Helmet>
                        <meta charSet="utf-8" />
                        <title>EKA - Appointments</title>
                    </Helmet>
                    {/* <CustomizeReceiptPopup /> */}
                    <AnimatePresence>
                        {MRUploadDialogVisible && files && uploadMrDialogPtId && (
                            <UploadDialog
                                files={files}
                                close={this.closeMRDialog}
                                setFiles={this.setFiles}
                                ptId={uploadMrDialogPtId}
                            />
                        )}
                        {MRRequestPt && (
                            <RequestMedicalRecords
                                isModalOpen={isMRRequestModalOpen}
                                closeMe={this.closeRequestMedicalRecords}
                                plId={MRRequestPtId}
                                patientDirectory={{
                                    id: MRRequestPtId,
                                    abha: MRRequestPt.abha,
                                }}
                                doctorprofile={doc}
                                setActiveTab={() => {
                                    this.props.history.push({
                                        pathname: GO_TO_PATIENTS_DETAILS(
                                            MRRequestPtId,
                                            'medical-records',
                                        ),
                                        state: {
                                            activeTab: 'request',
                                        },
                                    });
                                }}
                            />
                        )}
                    </AnimatePresence>
                    <AnimatePresence>
                        {vitalsModalAppointment && (
                            <ApptVitalsAndLabResultsRightPopUp
                                appointment={vitalsModalAppointment}
                                closeMe={this.closeVitalsDialog}
                            />
                        )}
                        {treatmentPlanModalAppointment && (
                            <ApptTreatmentPlanRightPopUp
                                appointment={treatmentPlanModalAppointment}
                                closeMe={this.onCloseTreatmentPlan}
                            />
                        )}
                        {admitPatientDrawerPatient && (
                            <AdmitPatientDrawer
                                closeMe={this.onCloseAdmitPatientDrawer}
                                patient={admitPatientDrawerPatient}
                            />
                        )}
                        {orderMedicineDialogVisible && (
                            <OrderMedicineDialog
                                closeMe={this.hideOrderMedicineDialogVisible}
                                formData={orderMedicineDialogVisible.formData}
                                pxid={orderMedicineDialogVisible.prescription_id || ''}
                                patientId={orderMedicineDialogVisible.patient_oid || ''}
                                name={orderMedicineDialogVisible.patient.fln || ''}
                                phone={
                                    orderMedicineDialogVisible.patient.mobile?.replace('+91', '') ||
                                    ''
                                }
                                gender={gen}
                                age={age}
                                clinicPin={currentClinic?.address?.pin || ''}
                            />
                        )}
                        {bookLabTestDialogVisible && (
                            <BookLabTestsDialog
                                closeMe={this.hideBookLabTestDialogVisible}
                                formData={bookLabTestDialogVisible.formData}
                                pxid={bookLabTestDialogVisible.prescription_id || ''}
                                patientid={bookLabTestDialogVisible.patient_oid || ''}
                                name={bookLabTestDialogVisible.patient.fln || ''}
                                phone={
                                    bookLabTestDialogVisible.patient.mobile?.replace('+91', '') ||
                                    ''
                                }
                                gender={gen}
                                age={age}
                            />
                        )}
                        {abhaPatientDialog && abhaDetails && (
                            <AddPtModal
                                close={() => this.setState({ abhaPatientDialog: false })}
                                isAbhaNewFlow={true}
                                defaultFormState="abha"
                                abhaLinkPatient={{
                                    id: abhaDetails.patient.oid || undefined,
                                    localId: abhaDetails.patient.oid || '',
                                    formData: abhaDetails.formData,
                                    personal: {
                                        name: {
                                            f: abhaDetails.patient?.fn || '',
                                            l: [
                                                abhaDetails.patient?.mn || '',
                                                abhaDetails.patient?.ln || '',
                                            ]
                                                .filter(Boolean)
                                                .join(' '),
                                        },
                                        phone: abhaDetails.patient.mobile
                                            ? {
                                                  c: '+91',
                                                  n: abhaDetails.patient.mobile.replace('+91', ''),
                                              }
                                            : undefined,
                                        age: {
                                            dob: abhaDetails.patient?.dob || '',
                                        },
                                        gender:
                                            GENDER_CODE_TO_NAME[abhaDetails.patient.gen || ''] ||
                                            '',
                                    },
                                }}
                                docid={selectedDocid}
                                onAbhaLink={() =>
                                    this.props.history.push(
                                        GO_TO_PATIENTS_DETAILS(
                                            abhaDetails.patient.oid ?? '',
                                            'visit',
                                            '',
                                        ),
                                    )
                                }
                                cId={this.props.match.params.cId}
                            />
                        )}
                        {editPatientDialog && (
                            <EditPatientDetailsDialog
                                visitId={editPatientDialog.aid}
                                pxId={editPatientDialog.localRxId}
                                docid={editPatientDialog.doctor_oid}
                                editPatient={{
                                    id: editPatientDialog.patient.oid || undefined,
                                    localId: editPatientDialog.patient.oid || '',
                                    formData: editPatientDialog.formData,
                                    personal: {
                                        name: {
                                            f: editPatientDialog.patient?.fn || '',
                                            l: [
                                                editPatientDialog.patient?.mn || '',
                                                editPatientDialog.patient?.ln || '',
                                            ]
                                                .filter(Boolean)
                                                .join(' '),
                                        },
                                        phone: editPatientDialog.patient?.mobile
                                            ? {
                                                  c: '+91',
                                                  n: editPatientDialog.patient?.mobile.replace(
                                                      '+91',
                                                      '',
                                                  ),
                                              }
                                            : undefined,
                                        age: {
                                            dob: editPatientDialog.patient?.dob || '',
                                        },
                                        gender:
                                            GENDER_CODE_TO_NAME[
                                                editPatientDialog.patient.gen || ''
                                            ] || '',
                                    },
                                }}
                                onComplete={this.editPatientComplete}
                                closeMe={this.closeEditPatientDialog}
                            />
                        )}
                        {newPatientDialog && (
                            <AddPtModal
                                defaultFormState={defaultFormState}
                                close={this.closeAddNewPatientModal}
                                isAbhaNewFlow={this.props.abhaNewFlow}
                                docid={selectedDocid}
                                cId={this.props.match.params.cId}
                            />
                        )}
                    </AnimatePresence>
                    <AnimatePresence>
                        {addAddressAppointment && (
                            <AddAddressModal
                                closeMe={() =>
                                    this.setState({
                                        addAddressAppointment: undefined,
                                    })
                                }
                                setAddress={this.setAddressHandler}
                                showForm={false}
                                patientId={addAddressAppointment?.patient_oid || ''}
                                pincode={pincode}
                            />
                        )}
                    </AnimatePresence>
                    <AnimatePresence>
                        {certPt && (
                            <MedicalCertificateDialog
                                patient={certPt}
                                closeMe={this.setMedicalCertPt}
                                clinicId={certClinicId}
                                docid={certPt.doctor_oid}
                            />
                        )}
                        {createTemplateAppointment && (
                            <CreateTemplateComp
                                isModal={true}
                                withPeak={false}
                                kind={ALL_KINDS['PX']}
                                onCancel={this.closeCreateTemplateDialog}
                                onSave={this.onSaveAsTemplate}
                                isCancelActive={true}
                            />
                        )}

                        {saAppointment && (
                            <motion.div
                                initial={{ opacity: 0 }}
                                exit={{ opacity: 0 }}
                                animate={{ opacity: 1 }}
                                style={{ zIndex: 20 }}
                                transition={{ duration: 0.2, ease: 'linear' }}
                                className="flex"
                            >
                                <div onClick={this.onCloseSa} className="modal-overlay" />
                                <div className="flex flex-col modal-content w-80p h-5/6">
                                    <div className="flex items-center justify-between p-16 border-b bg-neutral-9 rounded-t-8 border-neutral-7">
                                        <p className="font-700 text-neutral-1">
                                            Assessment Summary
                                        </p>
                                        <div
                                            className="flex items-center justify-center w-16 h-16 cursor-pointer"
                                            onClick={this.onCloseSa}
                                        >
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                viewBox="0 0 320 512"
                                                className="w-20 h-20 fill-neutral-5 hover:fill-neutral-black"
                                            >
                                                <path d="M207.6 256l107.72-107.72c6.23-6.23 6.23-16.34 0-22.58l-25.03-25.03c-6.23-6.23-16.34-6.23-22.58 0L160 208.4 52.28 100.68c-6.23-6.23-16.34-6.23-22.58 0L4.68 125.7c-6.23 6.23-6.23 16.34 0 22.58L112.4 256 4.68 363.72c-6.23 6.23-6.23 16.34 0 22.58l25.03 25.03c6.23 6.23 16.34 6.23 22.58 0L160 303.6l107.72 107.72c6.23 6.23 16.34 6.23 22.58 0l25.03-25.03c6.23-6.23 6.23-16.34 0-22.58L207.6 256z"></path>
                                            </svg>
                                        </div>
                                    </div>
                                    <AssessmentSummaryTab visitId={saAppointment.aid} />
                                    {section === 'today-queue' || section === 'upcoming'
                                        ? this.UPCOMING_SA_DIA_CTA(saAppointment)
                                        : this.CLOSE_SA_DIA_CTA()}
                                </div>
                            </motion.div>
                        )}

                        {referAP && referAP.patient.oid && (
                            <DoctorReferralAllPatient
                                ptId={referAP.patient.oid}
                                close={this.closeReferalDialog}
                                ptName={getPatientNameText(referAP.patient)}
                                docid={referAP.doctor_oid}
                            />
                        )}
                    </AnimatePresence>
                    <div className="grid grid-cols-queueGrid h-full min-w-840 overflow-x-auto overflow-y-hidden undefined">
                        <LeftBar />

                        <div className="flex flex-col w-full h-full col-span-11 overflow-hidden">
                            {/* {isDoctor() &&
                                !isOnboardedForPharma() &&
                                !isOnboardedForLab() &&
                                isHEDeactivated && (
                                    <Alert
                                        message="Warning: Please submit your bank details and pancard details to activate Health Exchange again!"
                                        showIcon
                                        type="error"
                                        action={
                                            <button
                                                className="text-13 font-700 px-16 py-5 my-3 rounded-4 bg-darwin-status-warning-500 text-white"
                                                onClick={() => this.goToHEOnboarding('home')}
                                            >
                                                Submit Details
                                            </button>
                                        }
                                    />
                                )} */}
                            {/* {isDoctor() &&
                                (isOnboardedForPharma() || isOnboardedForLab()) &&
                                isPancardDetailsMissing && (
                                    <Alert
                                        message="Warning: Please submit your pancard details to receive timely payouts!"
                                        showIcon
                                        type="error"
                                        action={
                                            <button
                                                className="text-13 font-700 px-16 py-5 my-3 rounded-4 bg-darwin-status-warning-500 text-white"
                                                onClick={() => this.goToHEOnboarding('pancard')}
                                            >
                                                Submit Details
                                            </button>
                                        }
                                    />
                                )} */}
                            <div className="flex items-center justify-end w-full">
                                <MRFileSelector
                                    fileUploadId={fileUploadId}
                                    onRefChange={this.onRefChange}
                                    onFilesSelect={this.onFilesSelect}
                                />
                                <NewHeaderComponent
                                    title="Queue"
                                    filterComponent={
                                        <div className="flex flex-1 items-center justify-between">
                                            <ClinicSelector
                                                onClinicSelect={(selectedClinicId) => {
                                                    setSelectedClinicId(selectedClinicId);
                                                    this.props.history.replace(
                                                        GO_TO_APPOINTMENTS(selectedClinicId),
                                                    );
                                                }}
                                            />
                                            <div className="flex items-center space-x-16">
                                                <div
                                                    className="rounded-8 flex items-center space-x-8 py-6 px-12 border border-darwin-neutral_new-200 cursor-pointer"
                                                    onClick={() => {
                                                        track('GLOBAL_SEARCH', { where: 'appt' });
                                                        this.props.dispatch(
                                                            toggleGlobalSearch(true),
                                                        );
                                                    }}
                                                >
                                                    <svg
                                                        width="24"
                                                        height="24"
                                                        viewBox="0 0 24 24"
                                                        fill="none"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                    >
                                                        <path
                                                            d="M19.75 18.7188C20.0625 19.0312 20.0625 19.5 19.75 19.7812C19.625 19.9375 19.4375 20 19.25 20C19.0312 20 18.8438 19.9375 18.6875 19.7812L14.5 15.5938C13.375 16.5 11.9688 17 10.4688 17C6.90625 17 4 14.0938 4 10.5C4 6.9375 6.875 4 10.4688 4C14.0312 4 16.9688 6.9375 16.9688 10.5C16.9688 12.0312 16.4688 13.4375 15.5625 14.5312L19.75 18.7188ZM5.5 10.5C5.5 13.2812 7.71875 15.5 10.5 15.5C13.25 15.5 15.5 13.2812 15.5 10.5C15.5 7.75 13.25 5.5 10.5 5.5C7.71875 5.5 5.5 7.75 5.5 10.5Z"
                                                            fill="#767676"
                                                        />
                                                    </svg>
                                                    <div className="text-13 flex gap-24 font-400 leading-4">
                                                        <span>Search</span>
                                                        {window?.navigator?.appVersion && (
                                                            <span>
                                                                {window?.navigator?.appVersion.indexOf(
                                                                    'Win',
                                                                ) != -1
                                                                    ? 'CTRL+K'
                                                                    : '⌘+K'}
                                                            </span>
                                                        )}
                                                    </div>
                                                </div>
                                                {typeof window.renderNewAppt === 'function' ? (
                                                    <div
                                                        style={{
                                                            color: '#215FFF',
                                                            border: '1px solid #215FFF',
                                                            borderRadius: '0.5rem',
                                                            fontSize: '13px',
                                                            fontWeight: 700,
                                                            cursor: 'pointer',
                                                            paddingLeft: '0.5rem',
                                                            paddingRight: '0.5rem',
                                                            paddingTop: '0.375rem',
                                                            paddingBottom: '0.375rem',
                                                            lineHeight: '1.125rem',
                                                        }}
                                                        className="flex items-center space-x-8 min-w-max h-42"
                                                        onClick={() => {
                                                            track('queue_switch_to_new_view', {});
                                                            window.localStorage.setItem(
                                                                'isNewView',
                                                                'true',
                                                            );
                                                            his.push(
                                                                GO_TO_NEW_APPOINTMENT(
                                                                    getSelectedClinicId() ||
                                                                        this.props.match.params.cId,
                                                                ),
                                                            );
                                                        }}
                                                    >
                                                        <svg
                                                            className="min-w-24 w-24 h-24 p-4"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            height="1em"
                                                            viewBox="0 0 512 512"
                                                        >
                                                            <path
                                                                d="M304 24c0 13.3 10.7 24 24 24H430.1L207 271c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l223-223V184c0 13.3 10.7 24 24 24s24-10.7 24-24V24c0-13.3-10.7-24-24-24H328c-13.3 0-24 10.7-24 24zM72 32C32.2 32 0 64.2 0 104V440c0 39.8 32.2 72 72 72H408c39.8 0 72-32.2 72-72V312c0-13.3-10.7-24-24-24s-24 10.7-24 24V440c0 13.3-10.7 24-24 24H72c-13.3 0-24-10.7-24-24V104c0-13.3 10.7-24 24-24H200c13.3 0 24-10.7 24-24s-10.7-24-24-24H72z"
                                                                fill="currentColor"
                                                            />
                                                        </svg>

                                                        <div>Switch to new view</div>
                                                    </div>
                                                ) : null}

                                                <GoToAddPatientBt
                                                    clinicId={this.props.match.params.cId}
                                                    newDesign={true}
                                                />
                                            </div>
                                        </div>
                                    }
                                />
                                {isHealthWeekDoctor && (
                                    <div className="relative">
                                        <p
                                            className="flex items-center uppercase italic rounded-4 text-white font-700 cursor-pointer whitespace-nowrap px-16 health-week-shimmer mr-16"
                                            style={{
                                                background:
                                                    'linear-gradient(98deg, #19A66A -12.79%, #0F6440 124.67%)',
                                            }}
                                            onClick={this.showHealthWeek}
                                        >
                                            Eka Health week
                                        </p>
                                        {showHealthWeekStripArrow && (
                                            <div
                                                className="absolute right-0 left-0 -bottom-10 w-16 h-16 flex items-center justify-center mx-auto"
                                                id={HEALTH_WEEK_STRIP}
                                            >
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    viewBox="0 0 320 512"
                                                    className="w-16 h-16"
                                                    style={{ fill: '#0F6440' }}
                                                >
                                                    <path d="M31.3 192h257.3c17.8 0 26.7 21.5 14.1 34.1L174.1 354.8c-7.8 7.8-20.5 7.8-28.3 0L17.2 226.1C4.6 213.5 13.5 192 31.3 192z" />
                                                </svg>
                                            </div>
                                        )}
                                    </div>
                                )}
                            </div>
                            {/* <div className="mt-8 mx-8">
                                <PurchaseEkaCreditsStrip />
                            </div> */}
                            <NewSignInStrip />
                            {isHealthWeekDoctor && (
                                <div className="mx-16 relative top-8" onClick={this.showHealthWeek}>
                                    <HealthWeekStrip showCloseButton />
                                </div>
                            )}
                            <div id="payment_banner_in_queue" className="w-full"></div>
                            <Alert
                                message={
                                    <span style={{ color: '#fff', fontWeight: 'bold' }}>
                                        WARNING : This view will be discontinued from June 5, 2025.
                                        You’ll be automatically moved to the new and improved queue
                                        experience. Try it now !
                                    </span>
                                }
                                showIcon
                                type="warning"
                                style={{
                                    backgroundColor: '#D74B41',
                                    color: '#fff',
                                    borderColor: '#fff',
                                }}
                                icon={
                                    <span>
                                        <svg
                                            width="18"
                                            height="16"
                                            viewBox="0 0 18 16"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                d="M9 16C6.125 16 3.5 14.5 2.0625 12C0.625 9.53125 0.625 6.5 2.0625 4C3.5 1.53125 6.125 0 9 0C11.8438 0 14.4688 1.53125 15.9062 4C17.3438 6.5 17.3438 9.53125 15.9063 12C14.4688 14.5 11.8438 16 9 16ZM9 4C8.5625 4 8.25 4.34375 8.25 4.75V8.25C8.25 8.6875 8.5625 9 9 9C9.40625 9 9.75 8.6875 9.75 8.25V4.75C9.75 4.34375 9.40625 4 9 4ZM8 11C8 11.5625 8.4375 12 9 12C9.53125 12 10 11.5625 10 11C10 10.4687 9.53125 10 9 10C8.4375 10 8 10.4687 8 11Z"
                                                fill="white"
                                            />
                                        </svg>
                                    </span>
                                }
                                action={
                                    <div className="flex items-center space-x-10">
                                        <button
                                            onClick={newQueueIntro}
                                            className="flex justify-center items-center space-x-8 rounded-4 p-8 px-15 ml-41 text-14 font-700 text-darwin-accent-bright-blue-800 bg-white announcekit-widget"
                                        >
                                            <span className="text-center text-14 font-700 whitespace-nowrap flex justify-center items-center space-x-8">
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="18"
                                                    height="18"
                                                    viewBox="0 0 16 16"
                                                    style={{ marginRight: '0.2rem' }}
                                                >
                                                    <circle cx="8" cy="8" r="7" fill="#007bff" />
                                                    <path fill="white" d="M5.5 3.5l6 4-6 4V3.5z" />
                                                </svg>
                                                See whats new!
                                            </span>
                                        </button>
                                        <div
                                            className="flex items-center space-x-8 min-w-max h-42 bg-darwin-accent-bright-blue-800 dr-rounded-6 font-bold cursor-pointer px-8 py-6 leading-5"
                                            onClick={() => {
                                                track(
                                                    'queue_switch_to_new_view_from_warning_strip',
                                                    {},
                                                );
                                                window.localStorage.setItem('isNewView', 'true');
                                                his.push(
                                                    GO_TO_NEW_APPOINTMENT(
                                                        getSelectedClinicId() ||
                                                            this.props.match.params.cId,
                                                    ),
                                                );
                                            }}
                                        >
                                            <svg
                                                className="min-w-24 w-24 h-24 p-4"
                                                xmlns="http://www.w3.org/2000/svg"
                                                height="1em"
                                                viewBox="0 0 512 512"
                                            >
                                                <path
                                                    d="M304 24c0 13.3 10.7 24 24 24H430.1L207 271c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l223-223V184c0 13.3 10.7 24 24 24s24-10.7 24-24V24c0-13.3-10.7-24-24-24H328c-13.3 0-24 10.7-24 24zM72 32C32.2 32 0 64.2 0 104V440c0 39.8 32.2 72 72 72H408c39.8 0 72-32.2 72-72V312c0-13.3-10.7-24-24-24s-24 10.7-24 24V440c0 13.3-10.7 24-24 24H72c-13.3 0-24-10.7-24-24V104c0-13.3 10.7-24 24-24H200c13.3 0 24-10.7 24-24s-10.7-24-24-24H72z"
                                                    fill="white"
                                                />
                                            </svg>
                                            <div className="text-white">Switch to new queue</div>
                                        </div>
                                    </div>
                                }
                            />
                            {showVideo && (
                                <ModalDialog>
                                    <IFrameBareDialog
                                        url={
                                            'https://www.youtube.com/embed/1XD-HZqdlaA?autoplay=1&mute=1'
                                        }
                                        id={'new_queue_intro_video'}
                                        closeMe={() => this.setState({ showVideo: false })}
                                        style={{ width: '720px', height: '476px' }}
                                    />
                                </ModalDialog>
                            )}
                            <div id={APPT_ID} className="h-full"></div>
                            {isStaff || !amIDoctorOnly() || meetDocAssistDisabled ? null : (
                                <div
                                    className={`fixed right-36 bottom-40 space-x-4 flex items-center justify-center cursor-pointer ${getAclViewClassName(
                                        SREV2.DOC_ASSIST,
                                    )}`}
                                    style={{
                                        backdropFilter: 'blur(5.200000286102295px)',
                                        boxShadow: '0px 15.6px 26px 0px rgba(0, 0, 0, 0.12)',
                                        background:
                                            'linear-gradient(125deg, rgba(255, 255, 255, 0.45) 3.01%, rgba(225, 225, 225, 0.62) 83.65%))',
                                        border: '1.3px solid #E7B3FF',
                                        borderRadius: '10px',
                                        padding:
                                            isMinimizeDocAssist === 'true'
                                                ? '6px 6px 6px 6px'
                                                : '6px 16px 6px 8px',
                                    }}
                                    onClick={this.openDialog}
                                >
                                    <video
                                        id={DOC_ASSIST_LOGO_VIDEO}
                                        style={{
                                            height: '40px',
                                            width: '40px',
                                            borderRadius: '50%',
                                        }}
                                        controls={false}
                                        autoPlay
                                        loop
                                    >
                                        <source src="/videos/doc-assist.mp4" type="video/mp4" />
                                    </video>
                                    {isMinimizeDocAssist !== 'true' && (
                                        <>
                                            <span
                                                className="text-13 font-700 mr-8"
                                                style={{
                                                    background:
                                                        'linear-gradient(92deg, #205CFF 17.16%, #CD9BEA 90.68%)',
                                                    backgroundClip: 'text',
                                                    WebkitBackgroundClip: 'text',
                                                    WebkitTextFillColor: 'transparent',
                                                }}
                                            >
                                                Meet DocAssist AI
                                            </span>

                                            <div
                                                className="absolute p-6 rounded-full -right-8 -top-8"
                                                style={{
                                                    background: '#484848',
                                                    opacity: '0.8',
                                                }}
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    this.minimizeDocAssist();
                                                }}
                                            >
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="7"
                                                    height="8"
                                                    viewBox="0 0 7 8"
                                                    fill="none"
                                                >
                                                    <path
                                                        d="M6.76562 6.43164C6.95898 6.64648 6.95898 6.96875 6.76562 7.16211C6.55078 7.37695 6.22852 7.37695 6.03516 7.16211L3.5 4.60547L0.943359 7.16211C0.728516 7.37695 0.40625 7.37695 0.212891 7.16211C-0.00195312 6.96875 -0.00195312 6.64648 0.212891 6.43164L2.76953 3.875L0.212891 1.31836C-0.00195312 1.10352 -0.00195312 0.78125 0.212891 0.587891C0.40625 0.373047 0.728516 0.373047 0.921875 0.587891L3.5 3.16602L6.05664 0.609375C6.25 0.394531 6.57227 0.394531 6.76562 0.609375C6.98047 0.802734 6.98047 1.125 6.76562 1.33984L4.20898 3.875L6.76562 6.43164Z"
                                                        fill="white"
                                                    />
                                                </svg>
                                            </div>
                                        </>
                                    )}
                                </div>
                            )}
                        </div>
                    </div>
                    {/* <SnackingQuestionsComponent /> */}
                    {/* <PageBottomPopover className="bottom-0" /> */}

                    {isDialogOpen && (
                        <ModalDialog>
                            <DocAssistComp
                                isGlobal={true}
                                closeMe={this.closeDialog}
                                docid={getDoctorSelectorList()[0].id}
                            />
                        </ModalDialog>
                    )}
                </div>
            </>
        );
    }
}

export default connect((state: GlobalState) => ({
    isHEDeactivated: getGenieSetting(state, 'isHEDeactivated') as boolean,
    isHealthWeekDoctorFlag: getGenieSetting(state, 'isHealthWeekDoctor') as boolean,
    isAbdmEnabled: getGenieSetting(state, 'abdm') as boolean,
    abhaNewFlow: false,
    refreshAllPatients: state.session.refreshPage,
    isMilestonesEnabled: getGenieSetting(state, 'showMilestone') as boolean,
}))(Appointments);
export { Appointments };

const VISIT_TYPE_MAP: {
    [key: string]: {
        icon: ReactNode;
        titleTextClassName: string;
        followUpIconFillClassName: string;
        title: string;
    };
} = {
    TELE: {
        icon: (
            <svg className="w-16 h-16 fill-icons-brand" viewBox="0 0 576 512">
                <path d="M557.6 102.3c-11.53-7.406-25.88-8.391-38.28-2.688L416 147V128c0-35.35-28.65-64-64-64H64C28.65 64 0 92.65 0 128v256c0 35.35 28.65 64 64 64h288c35.35 0 64-28.65 64-64v-19.02l103.3 47.36c5.344 2.453 11.03 3.672 16.69 3.672c7.531 0 15.02-2.141 21.59-6.359C569.1 402.3 576 389.7 576 375.1V136C576 122.3 569.1 109.8 557.6 102.3zM368 384c0 8.822-7.178 16-16 16H64c-8.822 0-16-7.178-16-16V128c0-8.822 7.178-16 16-16h288c8.822 0 16 7.178 16 16V384zM528 363.5L416 312.2V199.8l112-51.33V363.5z"></path>
            </svg>
        ),
        titleTextClassName: 'text-icons-brand',
        followUpIconFillClassName: 'fill-icons-brand',
        title: 'Teleconsultation',
    },
    WALKIN: {
        icon: (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 320 512"
                className="fill-accent-blue w-16 h-16"
            >
                <path d="M208 96c26.5 0 48-21.5 48-48S234.5 0 208 0s-48 21.5-48 48 21.5 48 48 48zm94.5 149.1l-23.3-11.8-9.7-29.4c-14.7-44.6-55.7-75.8-102.2-75.9-36-.1-55.9 10.1-93.3 25.2-21.6 8.7-39.3 25.2-49.7 46.2L17.6 213c-7.8 15.8-1.5 35 14.2 42.9 15.6 7.9 34.6 1.5 42.5-14.3L81 228c3.5-7 9.3-12.5 16.5-15.4l26.8-10.8-15.2 60.7c-5.2 20.8.4 42.9 14.9 58.8l59.9 65.4c7.2 7.9 12.3 17.4 14.9 27.7l18.3 73.3c4.3 17.1 21.7 27.6 38.8 23.3 17.1-4.3 27.6-21.7 23.3-38.8l-22.2-89c-2.6-10.3-7.7-19.9-14.9-27.7l-45.5-49.7 17.2-68.7 5.5 16.5c5.3 16.1 16.7 29.4 31.7 37l23.3 11.8c15.6 7.9 34.6 1.5 42.5-14.3 7.7-15.7 1.4-35.1-14.3-43zM73.6 385.8c-3.2 8.1-8 15.4-14.2 21.5l-50 50.1c-12.5 12.5-12.5 32.8 0 45.3s32.7 12.5 45.2 0l59.4-59.4c6.1-6.1 10.9-13.4 14.2-21.5l13.5-33.8c-55.3-60.3-38.7-41.8-47.4-53.7l-20.7 51.5z"></path>
            </svg>
        ),
        titleTextClassName: 'text-accent-blue',
        followUpIconFillClassName: 'fill-accent-blue',
        title: 'Walkin',
    },
    default: {
        icon: (
            <svg
                className="w-16 h-16 fill-textColor-secondary"
                role="img"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 448 512"
            >
                <path d="M216.1 408.1C207.6 418.3 192.4 418.3 183 408.1L119 344.1C109.7 335.6 109.7 320.4 119 311C128.4 301.7 143.6 301.7 152.1 311L200 358.1L295 263C304.4 253.7 319.6 253.7 328.1 263C338.3 272.4 338.3 287.6 328.1 296.1L216.1 408.1zM128 0C141.3 0 152 10.75 152 24V64H296V24C296 10.75 306.7 0 320 0C333.3 0 344 10.75 344 24V64H384C419.3 64 448 92.65 448 128V448C448 483.3 419.3 512 384 512H64C28.65 512 0 483.3 0 448V128C0 92.65 28.65 64 64 64H104V24C104 10.75 114.7 0 128 0zM400 192H48V448C48 456.8 55.16 464 64 464H384C392.8 464 400 456.8 400 448V192z"></path>
            </svg>
        ),
        titleTextClassName: 'text-textColor-secondary',
        followUpIconFillClassName: 'fill-textColor-secondary',
        title: 'Appointment',
    },
};

export const getVisitType = (a: AP): ReactNode => {
    const visitType = a['visit-type'] || '';
    const channel = a.channel;
    const service = a.service;

    const config =
        visitType in VISIT_TYPE_MAP ? VISIT_TYPE_MAP[visitType] : VISIT_TYPE_MAP['default'];

    return (
        <div className="flex flex-col xl:flex-row items-center space-x-4 py-8 px-8 break-all">
            <div className="flex items-center justify-center w-16 h-16">{config.icon}</div>
            <div>
                <p className="hidden xl:flex text-textColor-secondary text-13 flex items-center space-x-4">
                    <span className={`hidden xl:block ${config.titleTextClassName} text-13`}>
                        {service?.service_name || config.title}
                    </span>

                    {service?.appointment_type === 'FOLLOW_UP' && (
                        <div className="w-16 h-16">
                            {followUpIcon(config.followUpIconFillClassName)}
                        </div>
                    )}
                </p>
                {visitType !== 'WALKIN' && <p className="text-neutral-5 text-11">{channel}</p>}
            </div>
        </div>
    );
};

export const OptionItem: React.FC<{
    onClick?: (e: React.MouseEvent<HTMLDivElement>) => void;
    label: string;
    subLabel?: string;
    labelClassName?: string;
    isLoading?: boolean;
    rightIconFill?: string;
    rightIcon?: JSX.Element;
    className?: string;
}> = ({
    onClick,
    labelClassName,
    isLoading = false,
    label,
    subLabel,
    rightIconFill = 'fill-neutral-5',
    className,
}) => {
    return (
        <Menu.Item key={label + subLabel} className={`font-lato ${className ? className : ''}`}>
            <div
                onClick={(e) => {
                    onClick?.(e);
                    track('OPTION_SELECT', { option: label });
                }}
                className="flex justify-between py-8 px-4 text-neutral-2 font-600 cursor-pointer"
            >
                <div>
                    <p className={labelClassName}>{label}</p>
                    {subLabel && <p className="text-10 text-neutral-1 opacity-50">{subLabel}</p>}
                </div>
                {isLoading ? (
                    <div
                        className="pulse flex items-center mr-6 scale-110"
                        style={{ transform: 'scale(1.2)', height: '25px' }}
                    >
                        <svg width="16px" height="12px">
                            <polyline id="back" points="1 6 4 6 6 11 10 1 12 6 15 6"></polyline>
                            <polyline id="front" points="1 6 4 6 6 11 10 1 12 6 15 6"></polyline>
                        </svg>
                    </div>
                ) : (
                    <svg
                        width="25"
                        height="25"
                        viewBox="0 0 28 28"
                        className={`${rightIconFill} cursor-pointer`}
                        preserveAspectRatio="xMidYMid meet"
                    >
                        <path d="M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z"></path>
                    </svg>
                )}
            </div>
        </Menu.Item>
    );
};

export const getAppointmentActionText = (t: A_ACTION_TYPE): React.ReactNode => {
    switch (t) {
        case ONGOING:
            return <p className="font-700 text-status-success">Ongoing</p>;
        case START_VISIT:
            return 'Start Visit';
        case PARKED:
            return (
                <p className="font-700" style={{ color: '#D49A00' }}>
                    Parked
                </p>
            );
        case PARKED_ON_OTHER_DEVICE:
        case RE_START:
            return (
                <div className="relative">
                    <p className="font-700 text-status-success inline-flex">
                        {t === RE_START ? (
                            'Ongoing'
                        ) : (
                            <p className="font-700" style={{ color: '#D49A00' }}>
                                Parked
                            </p>
                        )}{' '}
                        <span className="self-start w-4 h-4 min-w-4 min-h-4  animate-pulse rounded-full bg-actionPrimary" />
                    </p>
                    {/* TODO ad tooltip */}
                    {/* <p className="tooltip"></p>
                    <span className="">
                        This will restart your visit. Any progress made will be lost.
                    </span> */}
                </div>
            );
        case ADD_PATIENT:
            return 'Add Patient';
        case ABORTED:
        case APPOINTMENT_DETAILS:
            return 'Appointment Details';
        default:
            return '';
    }
};
